import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';
import type { SupportedLanguage } from '../i18n';
import Icon from './Icon';

/**
 * Segmented language picker used on the Register and Profile screens.
 * Switches the UI language live; set `persistToServer` (logged-in users)
 * to also save the choice to the account via PATCH /auth/me.
 */
export default function LanguageSelector({
  persistToServer = false,
  onChanged,
}: {
  persistToServer?: boolean;
  onChanged?: (lang: SupportedLanguage) => void;
}) {
  const { language, options, setLanguage } = useLanguage();
  const { colors } = useTheme();

  return (
    <div style={{ display: 'flex', gap: 8 }}>
      {options.map(opt => {
        const active = language === opt.code;
        return (
          <button
            key={opt.code}
            type="button"
            onClick={() => { setLanguage(opt.code, persistToServer); onChanged?.(opt.code); }}
            aria-pressed={active}
            style={{
              flex: 1,
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              padding: '12px 10px', minHeight: 50, borderRadius: 10, cursor: 'pointer',
              border: `1.5px solid ${active ? '#14b8a6' : colors.inputBorder}`,
              backgroundColor: active ? colors.accentSoft : colors.input,
              transition: 'border-color 150ms ease, background-color 150ms ease',
            }}
          >
            <span style={{ fontSize: 18, lineHeight: 1 }}>{opt.flag}</span>
            <span style={{
              fontSize: 14, fontWeight: 700,
              color: active ? colors.accentText : colors.text,
            }}>
              {opt.nativeLabel}
            </span>
            {active && <Icon name="check" size={12} color="#14b8a6" />}
          </button>
        );
      })}
    </div>
  );
}
